<template>
  <basic-container>
    <el-dialog
      title="维修明细"
      :visible.sync="detailFlag"
      :modal-append-to-body="false"
      width="70%"
      @close="closeDetailDialog"
      append-to-body
    >
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page="page"
        :permission="permissionList"
        :before-open="beforeOpen"
        v-model="form"
        ref="crud"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/crmedical/device/repairtaskdeviceconsumable";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        detailFlag: false,
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: false,
          addBtn: false,
          editBtn: true,
          delBtn: false,
          indexLabel: '序号',
          columnBtn: false,
          align: 'center',
          menu: false,
          column: [
            {
              label: "耗材名称",
              prop: "consumableName",
            },
            {
              label: "规格",
              prop: "specification",
            },
            {
              label: "品牌",
              prop: "vender",
            },
            {
              label: "价格",
              prop: "price",
            },
            {
              label: "消耗数量",
              prop: "consumeNum",
            }
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.repairtaskdeviceconsumable_add, false),
          viewBtn: this.vaildData(this.permission.repairtaskdeviceconsumable_view, false),
          delBtn: this.vaildData(this.permission.repairtaskdeviceconsumable_delete, false),
          editBtn: this.vaildData(this.permission.repairtaskdeviceconsumable_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      openRepairTaskList(id) {
        this.detailFlag = true;
        this.query.taskDeviceId = id;
        this.onLoad();
      },
      closeDetailDialog(){
        this.detailFlag = false;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
